@if (marknadsomraden) {
  <div [formGroup]="form" class="row">
    <rask-selector
      class="col-6"
      label="Handelssortiment"
      formControlName="handelssortimentId"
      [formatter]="outputFormatter"
      [search]="searchForHandelssortiment"
      [viewFormatter]="formatter"
      [rule]="validation.handelssortimentRule">
    </rask-selector>
    <rask-tree-selector
      class="col-4"
      label="MO/RO/PO"
      [items]="marknadsomraden"
      [required]="false"
      [manualItemSync]="false"
      (change)="selectionChanged()"
      aid="styrningMoPoRo">
    </rask-tree-selector>
    <div class="col-2">
      <rask-icon-button (click)="delete()" icon="far fa-trash-alt" negative></rask-icon-button>
    </div>
  </div>
}
